/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: ehckhYnyDHgCBbV47m9bkf
// Component: DHHU9E4NuTqC

import * as React from "react";

import {
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  Flex as Flex__,
  StrictProps,
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";

import { _useGlobalVariants } from "./plasmic"; // plasmic-import: ehckhYnyDHgCBbV47m9bkf/projectModule
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: ehckhYnyDHgCBbV47m9bkf/styleTokensProvider

import "@plasmicapp/react-web/lib/plasmic.css";

import "./plasmic_plasmic_kit_pricing.css"; // plasmic-import: ehckhYnyDHgCBbV47m9bkf/projectcss
import sty from "./PlasmicCollaboratorsHoverContent.module.css"; // plasmic-import: DHHU9E4NuTqC/css

createPlasmicElementProxy;

export type PlasmicCollaboratorsHoverContent__VariantMembers = {};
export type PlasmicCollaboratorsHoverContent__VariantsArgs = {};
type VariantPropType = keyof PlasmicCollaboratorsHoverContent__VariantsArgs;
export const PlasmicCollaboratorsHoverContent__VariantProps =
  new Array<VariantPropType>();

export type PlasmicCollaboratorsHoverContent__ArgsType = {};
type ArgPropType = keyof PlasmicCollaboratorsHoverContent__ArgsType;
export const PlasmicCollaboratorsHoverContent__ArgProps =
  new Array<ArgPropType>();

export type PlasmicCollaboratorsHoverContent__OverridesType = {
  root?: Flex__<"div">;
};

export interface DefaultCollaboratorsHoverContentProps {
  className?: string;
}

const $$ = {};

function PlasmicCollaboratorsHoverContent__RenderFunc(props: {
  variants: PlasmicCollaboratorsHoverContent__VariantsArgs;
  args: PlasmicCollaboratorsHoverContent__ArgsType;
  overrides: PlasmicCollaboratorsHoverContent__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants,
  };

  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const globalVariants = _useGlobalVariants();

  const styleTokensClassNames = _useStyleTokens();

  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        "all",
        "__wab_text",
        "root_reset_ehckhYnyDHgCBbV47m9bkf",
        "plasmic_default_styles",
        "plasmic_mixins",
        styleTokensClassNames,
        sty.root
      )}
    >
      {"A collaborator is any editor or viewer of your projects."}
    </div>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: ["root"],
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  root: "div";
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicCollaboratorsHoverContent__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicCollaboratorsHoverContent__VariantsArgs;
    args?: PlasmicCollaboratorsHoverContent__ArgsType;
    overrides?: NodeOverridesType<T>;
  } & // Specify variants directly as props
  Omit<PlasmicCollaboratorsHoverContent__VariantsArgs, ReservedPropsType> &
    // Specify args directly as props
    Omit<PlasmicCollaboratorsHoverContent__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicCollaboratorsHoverContent__ArgProps,
          internalVariantPropNames:
            PlasmicCollaboratorsHoverContent__VariantProps,
        }),
      [props, nodeName]
    );
    return PlasmicCollaboratorsHoverContent__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName,
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicCollaboratorsHoverContent";
  } else {
    func.displayName = `PlasmicCollaboratorsHoverContent.${nodeName}`;
  }
  return func;
}

export const PlasmicCollaboratorsHoverContent = Object.assign(
  // Top-level PlasmicCollaboratorsHoverContent renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements

    // Metadata about props expected for PlasmicCollaboratorsHoverContent
    internalVariantProps: PlasmicCollaboratorsHoverContent__VariantProps,
    internalArgProps: PlasmicCollaboratorsHoverContent__ArgProps,
  }
);

export default PlasmicCollaboratorsHoverContent;
/* prettier-ignore-end */
